<template>
  <v-content class="">
    <section>
      <v-parallax
        :src="require('@/assets/beach-tsv2.jpg')"
        height="500"
        class="banner"
      >
        <Navbar></Navbar>

        <v-layout column class="white--text " justify-end>
          <div>
            <v-container justify-end>
              <div class=" display-1  mt-3 subpage-heading-1 ">
                Learn about storm surge damage to buildings
              </div>
              <div class=" headline  mt-3 subpage-heading-2 ">
                General information about storm surge damage
              </div>
            </v-container>
          </div>
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-container class=" white-background">
        <v-breadcrumbs divider=">">
          <v-breadcrumbs-item @click="gotoDamage">Damage</v-breadcrumbs-item>
          <v-breadcrumbs-item @click=""> > </v-breadcrumbs-item>
          <v-breadcrumbs-item @click="gotoStorm"
            >Storm Surge</v-breadcrumbs-item
          >
        </v-breadcrumbs>
        <v-layout column wrap class="" align-center>
          <v-flex xs12 class="my-3">
            <div class="text-xs-center">
              <h2 class="headline pa-2">Storm Surge Damage</h2>
              <span class="subheading pa-2"> General Information</span>
            </div>
            <div>
              <p class="pl-2 pr-2 pt-2">
                Storm surge is the rise in sea level caused by cyclonic winds.
                If the elevated sea level is higher than the lower floor level,
                the building will have seawater flowing through it. Where
                buildings are affected by storm surge they can be damaged by
                flooding, battering by waves and the erosion of soil and
                foundations by the sea water flowing past the building.
              </p>

              <p class="pl-2 pr-2 pt-2">
                The storm surge water contains a significant amount of debris
                such as sand, rocks, branches, damaged building material, trees,
                refuse, and loose items.
              </p>

              <p class="pl-2 pr-2 pt-2">
                Returning the building to service is delayed by the extensive
                clean-up required, damage to electrical wiring, and loss of
                equipment. Because the building has been inundated with
                seawater, many metal elements and fittings (including hidden
                details) are more susceptible to corrosion after a storm surge
                event.
              </p>
            </div>
          </v-flex>
          <v-flex style=" width: 100%">
            <v-carousel style="height: 100%; width: 100%" :cycle="cycle" dark>
              <v-carousel-item
                v-for="(item, i) in stormItems"
                :src="item.name"
                :key="i"
              >
                <v-responsive dark>
                  <v-container fill-height>
                    <v-layout align-center>
                      <v-flex aling-start justify-center>
                        <h3 class="display-1 white--text">
                          {{ item.heading }}
                        </h3>
                        <span class="subheading white--text font-weight-bold">{{
                          item.text
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-responsive>
              </v-carousel-item>
            </v-carousel>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <Footer></Footer>
  </v-content>
</template>

<style>
  .v-breadcrumbs__item{
    color: #1976D2;
    cursor: pointer;
  }
</style>

<script>
import Navbar from "./Navbar.vue";
import Footer from "./Footer.vue";
import { router } from "../router";

import image1 from "../assets/23_storm.jpg";
import image2 from "../assets/24_a_storm.jpg";
import image3 from "../assets/24_b_storm.jpg";
import image4 from "../assets/26_storm.jpg";

export default {
  name: "Storm",
  components: {
    Navbar,
    Footer
  },
  data: () => ({
    size: "sm",
    cycle: false,
    stormItems: [
      {
        name: image4,
        heading: "Storm Surge Damage",
        text: "Damage to footings "
      },
      {
        name: image3,
        heading: "Interior Damage",
        text:
          "Damage to the inside of apartments caused by sea water during a storm surge"
      },
      {
        name: image1,
        heading: "Storm Surge Damage",
        text: "Seawater flowing into a building"
      },
      {
        name: image2,
        heading: "Interior Damage",
        text:
          "Damage to the inside of apartments caused by sea water during a storm surge"
      }
    ]
  }),
  methods: {
    gotoDamage() {
      router.push("/damage");
    },
    gotoStorm() {
      router.push("/storm");
    }
  }
};
</script>
